export type BannersGridType = 'destaque_3_quadrados' | 'grade_2x2';

/**
 * Formatos do componente "Banners em Grid". O valor vai para `PageGroup.type` e e
 * o que o app usa para decidir o desenho -- por isso nao deve mudar depois de
 * publicado, sob pena de os grupos ja cadastrados pararem de renderizar.
 */
const bannersGridTypes: { label: string; value: BannersGridType }[] = [
  {
    label: 'Tipo 1 — 1 destaque + 3 quadrados',
    value: 'destaque_3_quadrados',
  },
  {
    label: 'Tipo 2 — 4 quadrados em 2 colunas',
    value: 'grade_2x2',
  },
];

export default bannersGridTypes;
